<h2>
  404 - Page not found
</h2>
@if (path) {
  <p>You might want to go to the <a [routerLink]="path">"{{ path }}" page</a></p>
}
